import { render, staticRenderFns } from "./EditCustomizationsPage.vue?vue&type=template&id=dfc30aae&"
import script from "./EditCustomizationsPage.vue?vue&type=script&lang=js&"
export * from "./EditCustomizationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports